export type NamePath = string | number | (string | number)[];
export type NameFn = (name: NamePath) => NamePath;

const buildNamePath = (rootName: NamePath) => (name: NamePath) => [rootName].flat(1).concat([name].flat(1));

export default buildNamePath;
